export default __webpack_public_path__ + "static/media/man.0c927cbb.png";